// When buyer downloads ppt
export const PPT_DOWNLOADED = 'download_ppt';
// When buyer downloads excel
export const EXCEL_DOWNLOADED = 'download_excel';
// This event is triggered when buyer clicks on “View Catalogue” button
export const LINK_OPEN = 'link_open';
// When buyer shortlists a product
export const SHORTLIST_PRODUCTS = 'shortlist_product';
// When buyer removes a shortlisted product
export const REMOVE_FROM_SHORTLIST = 'remove_from_shortlist';
// When buyer clicks on product modal
export const OPEN_PRODUCT_MODE = 'open_product_modal';
// When buyer downloads ppt for shortlisted products
export const DOWNLOAD_SHORTLISTED_PPT = 'download_shortlisted_ppt';
// When buyer sends a query
export const SEND_QUERY = 'send_query';
// view all buyers button
export const VIEW_ALL_BUYERS = 'view_all_buyers_btn';
// search keyword for buyers
export const SEARCH_KEYWORD_BUYERS = 'search_keyword_buyers';
// view buyer details
export const VIEW_BUYER_DETAILS = 'view_buyer_details';
// filter country select event for buyers
export const FILTER_SELECT_COUNTRY = 'filter_select_country';
// filter country deselect event for buyers
export const FILTER_DESELECT_COUNTRY = 'filter_deselect_country';
// filter hscode select event for buyers
export const FILTER_SELECT_HS_CODE = 'filter_select_hs_code';
// filter hscode deselect event for buyers
export const FILTER_DESELECT_HS_CODE = 'filter_deselect_hs_code';